export default "__VITE_ASSET__CWH8CJaM__"